class ConfiguratorStep2 {

    constructor(options) {

        const defaults = {
            container: '.js-configurations',
            item: '.js-configuration',
            materials: '.js-materials'
        };

        this.options = Object.assign(options, defaults);
        this.$container = $(this.options.container);
        this.$materials = $(this.options.materials);
        this.$no_image_alert = $('.no-image-alert');
        this.activated_configurations = false;

        this.init();

    }

    init() {

        console.log('configurator 2D init')

        let object = this;
        const $items = $(object.options.item);
        const firstMaterialCategory = $items.first().data('start-material-category')
        const firstMaterialNumber = $items.first().data('start-material-number')

        $items.on('click', function () {

            let ths = $(this);
            $items.removeClass('active');
            ths.addClass('active');
            object.activated_configurations = true;
            object.$materials.addClass('blocked-from-configurations');

            let configuration_id = ths.data('configuration-id');
            let product_id = object.$container.data('product-id');
            let material_name = object.$materials.find('.is-current').data('material-name');
            let material_color = object.$materials.find('.is-current').data('material-color');
            let material_type_id = object.$materials.find('.is-current').data('material-type-id');
            let material_type_name = object.$materials.find('.is-current').data('material-type-name');

            object.ajax_call({
                configuration_id: configuration_id,
                product_id: product_id,
                material_name: material_name,
                material_color: material_color,
                material_type_id: material_type_id,
                material_type_name: material_type_name,
            });
        });

        object.$materials.find('.js-material-item').on('click', function () {

            let ths = $(this);
            let configuration_id = object.$container.find('.js-configuration.active').data('configuration-id');
            let product_id = object.$container.data('product-id');
            let material_name = ths.data('material-name');
            let material_color = ths.data('material-color');
            let material_type_id = ths.data('material-type-id');
            let material_type_name = ths.data('material-type-name');

            if(object.activated_configurations) {
                object.ajax_call({
                    configuration_id: configuration_id,
                    product_id: product_id,
                    material_name: material_name,
                    material_color: material_color,
                    material_type_id: material_type_id,
                    material_type_name: material_type_name,
                });
            }
        });

        let $initialMaterial;

        if(firstMaterialNumber !== '') {
            $initialMaterial = object.$materials
              .find('[data-material-true-name="' + firstMaterialCategory + '"][data-material-color="' + firstMaterialNumber + '"]')
              .addClass('is-current')
        }
        else {
            $initialMaterial = object.$materials
              .find('[data-material-true-name="' + firstMaterialCategory + '"]').eq(0)
              .addClass('is-current')
        }

        object.$materials.find('.js-material-cat-item').removeClass('is-opened')
        object.$materials.find('.js-material-cat-body').css({display: 'none'})

        $initialMaterial.parents('.js-material-cat-item').addClass('is-opened')
        $initialMaterial.parents('.js-material-cat-body').css({display: 'block'})
        $items.first().click();
    }

    ajax_call(data) {

        let object = this;
        const $loader = $('.ajax-loader');

        const defaults = {
            action: 'get_configuration_info_step_2',
        };

        data = Object.assign(defaults, data);


        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'action' : data.action,
                'material_color' : data.material_color,
                'material_name' : data.material_name,
                'configuration_id' : data.configuration_id,
                'product_id' : data.product_id,
                'material_type_id': data.material_type_id,
                'material_type_name': data.material_type_name,
            },
            beforeSend: () => {
                $loader.addClass('active');
            },
            success: (response) => {

                // console.log(data);

                $('.js-product-selected-material').text(response.material_selected);
                $('.js-product-dimensions').text(response.dimensions);
                $('.js-product-dimensions-title').text(response.configuration_name);

                if(response.exists) {
                    $('.no-image-alert').hide();
                    $('.product-constructor__overview>img').attr('src', response.url);
                    // $('.product-constructor__price-value').text(response.price_from + ' грн');
                    $('.product-constructor__price-value').text((parseInt(response.price.replace(' ',''))*PL_CURRENCY).format(0, 3, ' ', ',') + ' ' + response.currency);
                }
                else {
                    $('.no-image-alert').show();
                }

            },

            error : function (jqXHR, exception) {
                let msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.log(msg);
            },
            complete: function () {
                setTimeout(function () {
                    $loader.removeClass('active');
                },300);
            }
        });
    }
};

export default ConfiguratorStep2;
